import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";
import DashboardTab from "../../pages/dashboard-edit/dashboard-edit-tab/DashboardTab"

const dashcharttabInit = {
  selectedTabId: 0,
  tabs: [
    {
      id: "dashboard",
      title: <DashboardTab />,
    },
  ],
};

function dashcharttabReducer(draft, { type, payload }) {
  switch (type) {
    case "setSelectedTabId": {
      draft.selectedTabId = payload;
      break;
    }
    case "addTab": {
      draft.tabs.push(payload);
      break;
    }
    case "deleteTab": {
      draft.tabs.splice(payload, 1);
      break;
    }
    // for charts (and for dashboards - todo)
    case "updateTab": {
      draft.tabs[draft.selectedTabId] = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [DashChartTabsContext, DashChartTabsDispatchContext] = [
  createContext(null),
  createContext(null),
];

export default function DashChartTabsProvider({ children, init, reducer }) {
  const [dashcharttabStore, dispatch] = useImmerReducer(
    reducer || dashcharttabReducer,
    init || dashcharttabInit
  );

  return (
    <DashChartTabsContext.Provider value={dashcharttabStore}>
      <DashChartTabsDispatchContext.Provider value={dispatch}>
        {children}
      </DashChartTabsDispatchContext.Provider>
    </DashChartTabsContext.Provider>
  );
}

export function useDashChartTabsStore() {
  return useContext(DashChartTabsContext);
}

export function useDashChartTabsDispatch() {
  return useContext(DashChartTabsDispatchContext);
}
